export default __webpack_public_path__ + "static/media/08.a34428d3.jpg";